"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/input/style/css");

var _input = _interopRequireDefault(require("antd/es/input"));

require("antd/es/form/style/css");

var _form = _interopRequireDefault(require("antd/es/form"));

var _react = _interopRequireDefault(require("react"));

var _ = _interopRequireWildcard(require("lodash"));

var _uuid = _interopRequireDefault(require("uuid"));

require("../activity.scss");

var _QuizQuestion = _interopRequireDefault(require("./QuizQuestion"));

var _FillInTheBlankQuestion = _interopRequireDefault(require("./FillInTheBlankQuestion"));

var _CategoryQuestion = _interopRequireDefault(require("./CategoryQuestion"));

var _DynamicFeedbackItems = _interopRequireDefault(require("../feedback/DynamicFeedbackItems"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const {
  Item
} = _form.default;
var Type;

(function (Type) {
  Type[Type["zero"] = 0] = "zero";
  Type[Type["quiz"] = 1] = "quiz";
  Type[Type["category"] = 2] = "category";
  Type[Type["category_no_answer"] = 3] = "category_no_answer";
  Type[Type["cyoa"] = 4] = "cyoa";
  Type[Type["fill_in_the_blank"] = 5] = "fill_in_the_blank";
  Type[Type["goals"] = 6] = "goals";
  Type[Type["ranking"] = 7] = "ranking";
  Type[Type["screener"] = 8] = "screener";
  Type[Type["question"] = 9] = "question";
})(Type || (Type = {}));

const defaultFeedback = {
  uuid: '',
  title: '',
  text: '',
  min: undefined,
  max: undefined,
  isOverallFeedback: false
};
const itemStyle = {
  width: '100%',
  marginBottom: '10px',
  marginTop: '10px'
};

const QuestionItem = props => {
  const {
    question,
    updateQuestion,
    typeId,
    disabled,
    options
  } = props;
  const {
    text,
    feedback,
    uuid,
    id
  } = question;

  const onTextChange = e => {
    e.preventDefault();
    question.text = e.target.value;
    updateQuestion(question);
  };

  const updateFeedback = (fb, index) => {
    if (question.feedback) {
      question.feedback[index] = fb;
      updateQuestion(question);
    }
  };

  const addFeedback = () => {
    const updatedQuestion = _.cloneDeep(question);

    const newFeedback = _.cloneDeep(defaultFeedback);

    newFeedback.uuid = (0, _uuid.default)();

    if (!updatedQuestion.feedback) {
      updatedQuestion.feedback = [newFeedback];
    } else {
      updatedQuestion.feedback[updatedQuestion.feedback.length] = newFeedback;
    }

    updateQuestion(updatedQuestion);
  };

  const removeFeedback = index => {
    let i = 0;
    question.feedback = question.feedback ? question.feedback.filter(f => {
      return index !== i++;
    }) : [];
    updateQuestion(question);
  };

  let item;

  switch (typeId) {
    case Type.quiz:
      item = /*#__PURE__*/_react.default.createElement(_QuizQuestion.default, {
        disabled: disabled,
        question: question,
        onTextChange: onTextChange,
        updateQuestion: updateQuestion
      });
      break;

    case Type.fill_in_the_blank:
      item = /*#__PURE__*/_react.default.createElement(_FillInTheBlankQuestion.default, {
        disabled: disabled,
        question: question,
        onTextChange: onTextChange,
        updateQuestion: updateQuestion
      });
      break;

    case Type.category:
      item = /*#__PURE__*/_react.default.createElement(_CategoryQuestion.default, {
        disabled: disabled,
        question: question,
        options: options,
        onTextChange: onTextChange,
        updateQuestion: updateQuestion
      });
      break;

    default:
      item = /*#__PURE__*/_react.default.createElement(_input.default, {
        spellCheck: true,
        disabled: disabled,
        placeholder: "Question text",
        value: text,
        onChange: onTextChange
      });
      break;
  }

  const displayFeedback = [Type.category].indexOf(typeId) === -1;
  return /*#__PURE__*/_react.default.createElement(Item, {
    key: id || uuid,
    style: itemStyle
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "question-container"
  }, item, displayFeedback && /*#__PURE__*/_react.default.createElement("h4", null, "Question Feedback:") && /*#__PURE__*/_react.default.createElement(_DynamicFeedbackItems.default, {
    type: Type.question,
    disabled: disabled,
    feedback: feedback || [],
    options: options || [],
    updateFeedback: updateFeedback,
    addFeedback: addFeedback,
    removeFeedback: removeFeedback
  })));
};

var _default = QuestionItem;
exports.default = _default;